import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0f83945a")
const _hoisted_1 = { class: "production-subject-container" }
const _hoisted_2 = { class: "title lager-font" }
const _hoisted_3 = { class: "content medi-font" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (Object.keys(_ctx.dataInfo).length > 0)
      ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          fit: "contain",
          radius: "10px",
          class: "logo",
          src: _ctx.getImgUrl(_ctx.dataInfo.imgs),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPreiviewImg(_ctx.dataInfo.imgs)))
        }, null, 8, ["src"]))
      : _createCommentVNode("", true),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.dataInfo.infoName), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.dataInfo.info), 1),
    (_ctx.dataInfo.phone)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "service-phone",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCall && _ctx.onCall(...args)))
        }, " 客服电话 "))
      : _createCommentVNode("", true)
  ]))
}